import { provideTranslocoScope } from '@jsverse/transloco';
import { scopeLoader } from '@core-utils';

export function provideUiKitScope() {
  return provideTranslocoScope({
    scope: 'uiKit',
    loader: scopeLoader(
      (lang: string, root: string) => import(`../${root}/${lang}.json`),
    ),
  });
}
